
const AudiencesSection = () => {
  const audiences = [
    {
      title: "Nonprofits & Foundations",
      features: [
        "Standardized application & intake workflows",
        "Document review & approval automation", 
        "Program retention dashboards"
      ],
      icon: "ri-heart-line"
    },
    {
      title: "Real Estate Teams / Brokerages",
      features: [
        "Automated lead qualification and follow-up systems",
        "Showing scheduling and pipeline dashboarding",
        "Concierge AI™ for inbound call handling"
      ],
      icon: "ri-home-line"
    },
    {
      title: "Local Service Businesses", 
      features: [
        "Appointment & client onboarding workflows",
        "Automated reminders & no-show reduction",
        "Centralized record & messaging history"
      ],
      icon: "ri-store-line"
    }
  ];

  return (
    <section className="py-20" style={{ backgroundColor: '#F8F4EF' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 
            className="text-4xl lg:text-5xl font-bold mb-6"
            style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
          >
            Who We Serve
          </h2>
          <p 
            className="text-xl max-w-3xl mx-auto"
            style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}
          >
            Specialized automation solutions tailored to your industry's unique operational needs.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {audiences.map((audience, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-2xl shadow-sm border"
              style={{ borderColor: '#C9B8A4' }}
            >
              <div 
                className="w-16 h-16 rounded-xl flex items-center justify-center mb-6"
                style={{ backgroundColor: '#F8F4EF' }}
              >
                <i 
                  className={`${audience.icon} text-2xl`}
                  style={{ color: '#7B6655' }}
                ></i>
              </div>
              
              <h3 
                className="text-2xl font-bold mb-6"
                style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
              >
                {audience.title}
              </h3>
              
              <ul className="space-y-4">
                {audience.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-start space-x-3">
                    <div 
                      className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
                      style={{ backgroundColor: '#E6DACD' }}
                    >
                      <i 
                        className="ri-check-line text-sm"
                        style={{ color: '#7B6655' }}
                      ></i>
                    </div>
                    <span 
                      className="leading-relaxed"
                      style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}
                    >
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AudiencesSection;
